import React from 'react';

/**
 * CardlessIcon - SVG icon component for cardless transactions
 * @returns {JSX.Element} SVG icon element
 */
const CardlessIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="246.04636785162288 84.456 325.61360123647603 430.84799999999996"
        width="19"
        height="23"
        fill="currentColor"
        style={{display: 'block'}}
    >
        <g>
            <g>
                <polygon
                    points="488.6 358.19 502.07 358.19 502.07 352.52 482.94 352.52 482.94 371.66 488.6 371.66 488.6 358.19"/>
                <polygon
                    points="541.58 352.52 541.58 358.19 555.05 358.19 555.05 371.66 560.72 371.66 560.72 352.52 541.58 352.52"/>
                <polygon
                    points="555.05 424.63 541.58 424.63 541.58 430.3 560.72 430.3 560.72 411.17 555.05 411.17 555.05 424.63"/>
                <polygon
                    points="488.6 411.17 482.94 411.17 482.94 430.3 502.07 430.3 502.07 424.63 488.6 424.63 488.6 411.17"/>
                <path
                    d="M492.06,361.5v23.62h23.62v-13.46h3.31v8.98h5.67v-10.16h-4.49v-3.31h4.49v-5.67h-5.67v4.49h-3.31v-4.49h-23.62ZM497.73,379.45v-12.28h12.28v12.28h-12.28Z"/>
                <path
                    d="M551.59,421.03v-23.62h-8.98v-3.31h8.98v-5.67h-8.98v-3.31h8.98v-23.62h-23.62v23.62h8.98v3.31h-12.28v-4.49h-5.67v8.98h-3.31v-4.49h-23.62v5.67h8.98v3.31h-4.49v4.49h-4.49v10.16h4.49v3.31h-4.49v5.67h5.67v-4.49h3.31v4.49h23.62v-5.67h-4.49v-4.49h-5.67v4.49h-7.79v-3.31h4.49v-4.49h4.49v-8.98h4.49v-4.49h16.77v3.31h-13.46v4.49h-4.49v5.67h4.49v4.49h4.49v8.98h23.62ZM533.64,415.36v-12.28h12.28v12.28h-12.28ZM524.66,406.38v-3.31h3.31v3.31h-3.31ZM538.12,392.92v-3.31h3.31v3.31h-3.31ZM545.92,367.17v12.28h-12.28v-12.28h12.28ZM510.01,406.38h-3.31v-12.28h7.79v3.31h-4.49v8.98ZM497.73,410.87v-7.79h3.31v7.79h-3.31Z"/>
                <rect height="5.67" width="5.67" y="370.47" x="501.04"/>
                <rect height="5.67" width="5.67" y="370.47" x="536.94"/>
                <rect height="5.67" width="5.67" y="406.38" x="536.94"/>
            </g>
            <g>
                <path
                    d="M562.81,178.21h-81.97c-3.08,0-5.59,2.51-5.59,5.59v9.31h93.14v-9.31c0-3.08-2.51-5.59-5.59-5.59Z"/>
                <path
                    d="M475.25,235.96c0,3.08,2.51,5.59,5.59,5.59h81.97c3.08,0,5.59-2.51,5.59-5.59v-31.67h-93.14v31.67ZM492.02,215.47h33.53c1.03,0,1.86.83,1.86,1.86s-.83,1.86-1.86,1.86h-33.53c-1.03,0-1.86-.83-1.86-1.86,0-1.03.83-1.86,1.86-1.86ZM492.02,222.92h18.63c1.03,0,1.86.83,1.86,1.86s-.83,1.86-1.86,1.86h-18.63c-1.03,0-1.86-.83-1.86-1.86s.83-1.86,1.86-1.86Z"/>
            </g>
            <g>
                <path
                    d="M547.21,301.76c-1.04-.02-2.03-.42-2.78-1.13-.35-.38-.62-.82-.82-1.29-.2-.47-.31-.98-.31-1.49,0-2.16,1.75-3.91,3.91-3.91s3.91,1.75,3.91,3.91c0,.51-.11,1.02-.31,1.49-.2.47-.48.91-.82,1.29-.75.72-1.74,1.13-2.78,1.13Z"/>
                <path
                    d="M561.05,259.6h-78.45c-4.11,0-7.45,3.34-7.45,7.45v61.59c0,4.11,3.34,7.45,7.45,7.45h78.45c4.11,0,7.45-3.34,7.45-7.45v-61.59c0-4.11-3.34-7.45-7.45-7.45ZM484.25,327.01v-58.31h75.16v13.71h-12.59c-8.52,0-15.44,6.93-15.44,15.44s6.93,15.44,15.44,15.44h12.59v13.71h-75.16ZM559.41,304.2h-12.59c-3.5,0-6.35-2.85-6.35-6.35s2.85-6.35,6.35-6.35h12.59v12.69Z"/>
            </g>
        </g>
        <g>
            <path
                d="M390.56,460.94c-4.23-.06-8.29-1.72-11.36-4.64-1.41-1.55-2.55-3.34-3.36-5.28-.82-1.92-1.26-3.99-1.28-6.08,0-8.84,7.16-16,16-16s16,7.16,16,16c-.02,2.09-.46,4.16-1.28,6.08-.81,1.94-1.95,3.73-3.36,5.28-3.05,2.95-7.12,4.61-11.36,4.64Z"/>
            <path
                d="M510.3,428.7v53.56c0,4.72-3.83,8.55-8.55,8.55h-222.39c-4.72,0-8.55-3.83-8.55-8.55V118.05c0-4.72,3.83-8.55,8.55-8.55h222.39c4.72,0,8.55,3.83,8.55,8.55v53.56h23.11v-53.56c0-17.46-14.2-31.66-31.66-31.66h-222.39c-17.46,0-31.66,14.2-31.66,31.66v364.21c0,17.46,14.2,31.66,31.66,31.66h222.39c17.46,0,31.66-14.2,31.66-31.66v-53.56h-23.11Z"/>
        </g>
    </svg>
);

export default CardlessIcon;
